import request from '../../../api/request';

export const STUDENT_ACTIONS_API = {
  GET_STUDENT_ACTIONS: (studentId: string | number) =>
    `/maintainers-portal/student-warnings/observations/actions/${studentId}`,
  CREATE_STUDENT_ACTION: (studentId: string | number) =>
    `/maintainers-portal/student-warnings/observations/actions/${studentId}`,
  CREATE_STUDENT_ACTION_RECORD: (
    studentId: string | number,
    actionId: string | number,
  ) =>
    `/maintainers-portal/student-warnings/observations/actions/${studentId}/records/${actionId}`,
};

export interface StudentAction {
  id: number;
  groupType: 'academic' | 'health' | 'behavior';
  actionType: string;
  owner: string;
  notes: string;
  sessionId: number | null;
  studentId: number;
  adminAccountId: number;
  createdAt: string;
  updatedAt: string;
  session?: {
    id: number;
    name: string;
  };
  adminAccount?: {
    id: number;
    name: string;
  };
  records?: StudentActionRecord[];
}

export interface StudentActionRecord {
  id: number;
  actionId: number;
  notes: string;
  adminAccountId: number;
  createdAt: string;
  updatedAt: string;
  adminAccount?: {
    id: number;
    name: string;
  };
}

export interface StudentActionsResponse {
  actions: StudentAction[];
  formOptions: {
    warningGroupOptions: Array<{ label: string; value: string }>;
    actionTypesOptions: Array<{ label: string; value: string }>;
  };
}

export interface CreateStudentActionData {
  groupType: string;
  actionType: string;
  owner: string;
  notes: string;
  sessionId?: number;
}

export interface CreateStudentActionRecordData {
  notes: string;
}

export function getStudentActions(
  studentId: string | number,
  params?: { sessionId?: number },
) {
  return request<StudentActionsResponse>(
    STUDENT_ACTIONS_API.GET_STUDENT_ACTIONS(studentId),
    {
      params,
    },
  );
}

export function createStudentAction(
  studentId: string | number,
  data: CreateStudentActionData,
) {
  return request<StudentAction>(
    STUDENT_ACTIONS_API.CREATE_STUDENT_ACTION(studentId),
    {
      method: 'POST',
      data,
    },
  );
}

export function createStudentActionRecord(
  studentId: string | number,
  actionId: string | number,
  data: CreateStudentActionRecordData,
) {
  return request<StudentActionRecord>(
    STUDENT_ACTIONS_API.CREATE_STUDENT_ACTION_RECORD(studentId, actionId),
    {
      method: 'POST',
      data,
    },
  );
}
